export const ITEMS_TRUNCATE_LINES = 5
